// Port of kit.css's .light rules (thinking/design/quies/foundations/kit.css).

.light {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: var(--qs-light-session-halo);
  height: var(--qs-light-session-halo);
  border-radius: 50%;
  background: var(--qs-light-halo-gradient);

  &::after {
    content: '';
    width: var(--qs-light-session-core);
    height: var(--qs-light-session-core);
    border-radius: 50%;
    background: var(--qs-color-glow-core);
  }
}

.light--hero {
  width: var(--qs-light-hero-halo);
  height: var(--qs-light-hero-halo);

  &::after {
    width: var(--qs-light-hero-core);
    height: var(--qs-light-hero-core);
  }
}

.light--inline {
  width: var(--qs-light-inline-halo);
  height: var(--qs-light-inline-halo);

  &::after {
    width: var(--qs-light-inline-core);
    height: var(--qs-light-inline-core);
  }
}

.light--dim {
  opacity: 0.35;
}

.light--breath {
  animation: qsBreath calc(var(--qs-motion-breath-in) + var(--qs-motion-breath-out)) var(--qs-motion-ease-breath) infinite;
}

@keyframes qsBreath {
  0% { transform: scale(0.86); opacity: 0.62; }
  40% { transform: scale(1.06); opacity: 1; }
  100% { transform: scale(0.86); opacity: 0.62; }
}

@keyframes qsBreathStill {
  0% { opacity: 0.62; }
  40% { opacity: 1; }
  100% { opacity: 0.62; }
}

@media (prefers-reduced-motion: reduce) {
  .light--breath {
    animation-name: qsBreathStill;
  }
}
